<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="是否启用：" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="弹出类型：" prop="popType">
            <el-radio-group v-model="ruleForm.popType">
              <el-radio :label="1">按日弹出</el-radio>
              <el-radio :label="2">按次弹出</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="弹框图片：" prop="icon">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="跳转类型：" prop="type">
            <el-select style="width: 424px;" v-model="ruleForm.type" placeholder="请选择跳转类型">
              <el-option label="不跳转" :value="0"></el-option>
              <el-option label="内部跳转" :value="1"></el-option>
              <el-option label="跳转外部链接" :value="2"></el-option>
              <el-option label="跳转小程序" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 1" label="内部链接：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入跳转链接"></el-input>
            <div class="mt-warm-txt"><span>商品路径：/pages/cate/cate?dataId=</span><span>ID在商品列表获取</span></div>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 2" label="外部链接：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入跳转链接"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 3" label="跳转小程序：" prop="minAppId">
            <el-input style="width: 424px;" v-model="ruleForm.minAppId" placeholder="请输入小程序appid"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 3" label="小程序路径：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入小程序路径"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveOrUpdatePopupAd, fetchPopupAdDetail } from '@/api/popup'
export default {
  name: 'Banner_add',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fileList: [],
      ruleForm: {
        status: '',
        popType: '',
        icon:'',
        type: '',
        url: '',
        minAppId: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择是否启用', trigger: 'blur' }
        ],
        popType: [
          { required: true, message: '请选择弹窗类型', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传弹窗图片', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        minAppId: [
          { required: true, message: '请输入小程序appid', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let that = this
    fetchPopupAdDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.status = data.status
        that.ruleForm.popType = data.popType
        if(data.icon != null){
          that.ruleForm.icon = data.icon
          that.fileList.push({url: data.icon})
        }
        that.ruleForm.type = data.type == null ? '' : data.type
        that.ruleForm.url = data.url == null ? '' : data.url
        that.ruleForm.minAppId = data.minAppId == null ? '' : data.minAppId
      }
    })
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.icon = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var icon = '';
      fileList.forEach(function(item){
        icon = item.url;
      });
      this.ruleForm.icon = icon;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let status = that.ruleForm.status
      let popType = that.ruleForm.popType
      let type = that.ruleForm.type
      let icon = that.ruleForm.icon
      let url = that.ruleForm.url
      var minAppId = that.ruleForm.minAppId
      if (status === '') {
        this.$message.error('请选择是否启用')
        return false
      }
      if (popType === '') {
        this.$message.error('请选择弹出类型')
        return false
      }
      if (icon === '') {
        this.$message.error('请上传弹窗图片')
        return false
      }
      if (type === '') {
        this.$message.error('请选择跳转类型')
        return false
      }
      if (type == 1 && url === '') {
        this.$message.error('请输入内部链接')
        return false
      }
      if (type == 2 && url === '') {
        this.$message.error('请输入外部链接')
        return false
      }
      if (type == 3 && minAppId === '') {
        this.$message.error('请输入小程序appid')
        return false
      }
      if (type == 3 && url === '') {
        this.$message.error('请输入小程序路径')
        return false
      }
      let passData = {
        popType: popType, icon: icon, status: status, type: type, minAppId: minAppId, url: url
      }
      saveOrUpdatePopupAd(passData).then((res) => {
       that.backDataFun(res)
      })
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/banner/Popup.vue